import Box from '@mui/material/Box';
import ConversionAdsHelmet from '../CoversionAdsHelmet';
import { BASE_TITLE } from '../Common';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useForm } from "react-hook-form";
import { emailRequest } from '../ApiRoute';
import { CONTACT_ADDRESSEE,EMAIL_FORMAT } from '../Common';

const useStyles = makeStyles((theme) => ({
    Container: {
        backgroundColor: '#FFFFFF',
        borderRadius: 8,
        border: '1px solid #E9EBED',
        boxShadow: '0 4px 14px rgba(47, 57, 65, 0.08)',
        padding: '1.5rem 2rem',
    },
    Description: {
        textAlign: 'center',
        marginBottom: '1rem!important',
        '&>p': {
            fontSize: '28px',
            color: theme.palette.text.secondary,
            fontWeight: '500!important',
            margin: 0,
        },
    },
    FormItem: {
        marginBottom: '2rem!important',
    },
}));

const Index = () => {
    const classes = useStyles();
    const { register, formState: { errors }, handleSubmit } = useForm({
        defaultValues: { webOutSourcing: false,appOutSourcing:false,icareProduct:false },
    });
    const { nameRef,...nameInputProps } = register("name", {
        required: "姓名為必填"
    });
    const { companyNameRef,...companyNameInputProps } = register("companyName", {
        required: "公司名稱為必填"
    });
    const { emailRef,...emailInputProps} = register("email", {
        required: "email為必填",pattern:{value:EMAIL_FORMAT,message:"email格式錯誤"}
    });
    const { contactPhoneRef,...contactPhoneInputProps } = register("contactPhone", {
        required: "連絡電話為必填"
    });
    const { webOutSourcingRef,...webOutSourcingInputProps} = register("webOutSourcing",{});
    const { appOutSourcingRef,...appOutSourcingInputProps} = register("appOutSourcing",{});
    const { icareProductRef,...icareProductInputProps} = register("icareProduct",{});
    const { messageRef,...messageInputProps } = register("message", {
        required: "需求說明為必填"
    });
    const onSubmit = (data)=>{
        emailRequest.post("/Send",
        {...data,addressee:CONTACT_ADDRESSEE}).then(()=>{
            alert("送出成功")
        }).catch((err)=>{
            if(err.response){
                alert(err.response.data);
            }
        })
    }
    return (<>
        <ConversionAdsHelmet title={BASE_TITLE + "聯絡我們"} />
        <FormControl component="article" fullWidth>
            <Grid container>
                <Grid item lg={9} className={classes.Container} style={{ marginLeft: "auto", marginRight: "auto", marginBottom: "3rem" }}>
                    <Box className={classes.Description}>
                        <p>請將基本資料與您的需求告訴我們</p>
                        <p>或撥打匯融聯絡電話: 0906698289</p>
                    </Box>
                    <Box>
                        <Grid container>
                            <Grid item lg={12} xl={7} style={{ marginLeft: "auto", marginRight: "auto" }}>
                                <form noValidate="" onSubmit={handleSubmit(onSubmit)}>
                                    <TextField error={!!errors.name}
                                        helperText={errors?.name?.message}
                                        inputRef={nameRef} {...nameInputProps}
                                        label="姓名" fullWidth className={classes.FormItem} />
                                    <TextField error={!!errors.companyName}
                                        helperText={errors?.companyName?.message} {...companyNameInputProps}
                                        inputRef={companyNameRef} label="公司名稱" fullWidth className={classes.FormItem} />
                                    <TextField error={!!errors.email}
                                        helperText={errors?.email?.message} {...emailInputProps}
                                        inputRef={emailRef} label="Email" fullWidth className={classes.FormItem} />
                                    <TextField error={!!errors.contactPhone}
                                        helperText={errors?.contactPhone?.message} {...contactPhoneInputProps}
                                        inputRef={contactPhoneRef} label="連絡電話" fullWidth className={classes.FormItem} />
                                    <FormGroup className={classes.FormItem}>
                                        <FormControlLabel control={<Checkbox inputRef={webOutSourcingRef} {...webOutSourcingInputProps}/>} label="Web 應用委外建置" />
                                        <FormControlLabel control={<Checkbox inputRef={appOutSourcingRef} {...appOutSourcingInputProps}/>} label="APP 系統委外建置" />
                                        <FormControlLabel control={<Checkbox inputRef={icareProductRef} {...icareProductInputProps}/>} label="AI 應用系統服務" />
                                    </FormGroup>
                                    <TextField error={!!errors.message}
                                        helperText={errors?.message?.message} {...messageInputProps}
                                        inputRef={messageRef} label="需求說明" multiline rows={10} fullWidth className={classes.FormItem} />
                                    <Button type="submit" variant="contained" color="primary" size="large" sx={{ px: 4 }}>送出您的需求</Button>
                                </form>

                            </Grid>

                        </Grid>

                    </Box>
                </Grid>
            </Grid>
        </FormControl>
    </>)
}

export default Index;